import { router } from "@inertiajs/react";
import { useState } from "react";
import ClearTestUserDialog from "@/components/domains/ClearTestUserDialog";
import type { DomainTestUser } from "@/types";

type Props = {
  domainId: string;
  testUser: DomainTestUser;
  onEdit: () => void;
};

export default function DomainTestUserConfigured({ domainId, testUser, onEdit }: Props) {
  const [confirming, setConfirming] = useState(false);
  const [clearing, setClearing] = useState(false);
  const methodLabel = testUser.auth_method === "instructions" ? "Custom sign-in" : "Password sign-in";
  const summary =
    testUser.auth_method === "instructions" ? "Login instructions are set" : (testUser.email ?? "Email and password");

  function clearTestUser() {
    if (clearing) {
      return;
    }

    setClearing(true);
    router.delete(`/domains/${domainId}/test_user`, {
      preserveScroll: true,
      onFinish: () => setClearing(false),
    });
  }

  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <p className="font-medium text-gray-900">{summary}</p>
        <p className="text-sm text-gray-500">{methodLabel}</p>
      </div>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
        <button
          type="button"
          className="cursor-pointer text-sm font-medium text-primary hover:underline"
          onClick={onEdit}
        >
          Edit
        </button>
        <button
          type="button"
          className="cursor-pointer text-sm font-medium text-gray-500 hover:text-error hover:underline"
          onClick={() => setConfirming(true)}
        >
          Clear
        </button>
      </div>
      <ClearTestUserDialog
        open={confirming}
        processing={clearing}
        onCancel={() => setConfirming(false)}
        onConfirm={clearTestUser}
      />
    </div>
  );
}
